import React from 'react';
import classNames from 'classnames';

import css from './IconVisa.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconVisa = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="35"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#7DC0F4" />
      <path d="M14.9751 16.0828H12.9961L14.2339 8.4292H16.2128L14.9751 16.0828Z" fill="#00579F" />
      <path
        d="M22.1473 8.61637C21.757 8.46151 21.1379 8.29053 20.3723 8.29053C18.418 8.29053 17.0418 9.33267 17.0334 10.8226C17.0172 11.9219 18.0187 12.5325 18.7678 12.899C19.5334 13.2735 19.7937 13.518 19.7937 13.8518C19.7859 14.3646 19.175 14.6009 18.6053 14.6009C17.8152 14.6009 17.3918 14.4791 16.7485 14.1938L16.4879 14.0715L16.2109 15.7896C16.6751 16.0011 17.5302 16.1887 18.418 16.1969C20.4945 16.1969 21.8464 15.1709 21.8624 13.5831C21.8703 12.7119 21.3414 12.0443 20.2013 11.4988C19.5091 11.1486 19.0852 10.9124 19.0852 10.5541C19.0933 10.2284 19.4437 9.89475 20.2251 9.89475C20.8684 9.87841 21.3411 10.0331 21.6992 10.1878L21.8782 10.2691L22.1473 8.61637Z"
        fill="#00579F"
      />
      <path
        d="M24.7786 13.3714C24.9416 12.9317 25.5687 11.23 25.5687 11.23C25.5605 11.2463 25.7314 10.7822 25.8291 10.4972L25.9674 11.1567C25.9674 11.1567 26.3421 12.9887 26.4235 13.3714C26.1142 13.3714 25.1695 13.3714 24.7786 13.3714ZM27.2214 8.4292H25.6907C25.2186 8.4292 24.86 8.5675 24.6563 9.06422L21.7168 16.0827H23.7933C23.7933 16.0827 24.1351 15.1381 24.2086 14.9346C24.4364 14.9346 26.4564 14.9346 26.7495 14.9346C26.8063 15.2033 26.9856 16.0827 26.9856 16.0827H28.8179L27.2214 8.4292Z"
        fill="#00579F"
      />
      <path
        d="M11.343 8.4292L9.40489 13.6482L9.1931 12.5897C8.83479 11.3684 7.71106 10.0414 6.45703 9.38162L8.23224 16.0747H10.325L13.4356 8.4292H11.343Z"
        fill="#00579F"
      />
      <path
        d="M7.60328 8.4292H4.41929L4.38672 8.58384C6.87043 9.21897 8.51534 10.7499 9.19116 12.5901L8.499 9.07255C8.38504 8.58373 8.03485 8.44532 7.60328 8.4292Z"
        fill="#FAA61A"
      />
    </svg>
  );
};

export default IconVisa;
